import Axios from "../../Config/API";
import {
    IContatoComTelefoneResponse,
    IContatos,
} from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import Service from "../../Service";

export async function ListarContatosService(IDConta: number, idCaso?: number) {
    return Service(
        Axios.get<Array<IContatos>>(
            `/home/contato/listarcontatos?IDConta=${IDConta}&idCaso=${idCaso}`
        )
    );
}

export async function ListarContatosComTelefoneService(idConta?: number) {
    return Service(
        Axios.get<Array<IContatoComTelefoneResponse>>(
            `/home/contatotelefone/listarcontatoscomtelefone?IDConta=${idConta}`
        )
    );
}

export async function GetInfoContatoService(nrTelefone: String) {
    return Service(
        Axios.get(`/home/contato/getinfocontato?nrTelefone=${nrTelefone}`)
    );
}

export async function DeletarContatoService(
    IDContato: number,
    IdConta?: number
) {
    return Service(
        Axios.delete(
            `/home/contato/deletarcontato?IDContato=${IDContato}${
                IdConta ? `&IdConta=${IdConta}` : ""
            }`
        )
    );
}

export async function CadastrarContatoService(
    requestBody: IContatos,
    IDConta: number,
    IDRelacaoCliente: number
) {
    return Service(
        Axios.post(
            `/home/contato/cadastrarcontato?IDConta=${IDConta}&IDRelacaoCliente=${IDRelacaoCliente}`,
            requestBody
        )
    );
}

export async function AtualizarContatoService(
    requestBody: IContatos,
    IDRelacaoCliente: number,
    atualizarUAU: boolean
) {
    return Service(
        Axios.put(
            `/home/contato/atualizarcontato?IDRelacaoCliente=${IDRelacaoCliente}&atualizarUAU=${atualizarUAU}`,
            requestBody
        )
    );
}
